import { Dispatch } from "redux";
import URLConstants from "../constants/url.constants";
import * as services from "../services/services";
import iaqRealtimeViewDataType from "../types/iaqRealtimeView.type";

export const getRealtimeViewChartData = (data: any) => {
  return (dispatch: Dispatch) => {
    dispatch(getRealtimeViewChartDataStart());
    let url =
      URLConstants.GetIAQRealtimeViewChartDataByICCID + "?ICCID=" + data.ICCID + "&Date=" + data.Date;
    services
      .get(url)
      .then((response) => {
        dispatch(getRealtimeViewChartDataSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getRealtimeViewChartDataError(err));
      });
  };
};

const getRealtimeViewChartDataStart = () => {
  return {
    type: iaqRealtimeViewDataType.GET_IAQ_REALTIME_VIEW_CHART_DATA_START,
  };
};

const getRealtimeViewChartDataSuccess = (data: any) => {
  return {
    type: iaqRealtimeViewDataType.GET_IAQ_REALTIME_VIEW_CHART_DATA_SUCCESS,
    payload: data,
  };
};

const getRealtimeViewChartDataError = (data: any) => {
  return {
    type: iaqRealtimeViewDataType.GET_IAQ_REALTIME_VIEW_CHART_DATA_ERROR,
    payload: data,
  };
};

export const resetRealtimeViewChartDataState = () => {
  return (dispatch: Dispatch) => {
    dispatch(resetRealtimeViewChartDataDispatcher());
  };
};

const resetRealtimeViewChartDataDispatcher = () => {
	return {
		type: iaqRealtimeViewDataType.RESET_IAQ_REALTIME_VIEW_CHART_DATA
	};
};